import {useParams} from 'react-router';
import {useQuery} from '@apollo/client/react';
import {Alert, Skeleton} from 'antd';

import {QUERY_CLIENT} from '../../../../shared/graphql/admin/clients';
import {Card, IUserData} from '../../../Index/Card';

export const Balance = () => {

    const {id} = useParams()

    const query = useQuery(QUERY_CLIENT, {
        variables: {
            documentId: id!,
        },
        skip: !id,
    })

    if (query.loading) return <Skeleton active/>

    const client = query.data?.client
    if (!client) return <Alert type={'error'} message={'Ребёнок не найден'}/>

    const phone = client.phone
    if (!phone) return <Alert type={'warning'} message={'У ребёнка не указан номер в IIKO'}/>

    const data: IUserData = {
        id: client.documentId,
        phone,
        group: client.group?.name,
        firstName: client.firstName,
        lastName: client.lastName,
        birthday: client.birthday,
    }

    return (
        <Card data={data}/>
    )
}